import AppCard from './AppCard';

export default AppCard;
